import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfcDropdown {
    static create(data, label, field, refreshFields, activeValue) {
        var dd = $('<div class="zfc-dropdown-wrapper"></div>'), ddLabel = $('<div class="zfc-dropdown-label"></div>'), ddContainer = $('<div class="zfc-dropdown-container"></div>'), listWrapper = $('<div class="zfc-dropdown-list-wrapper"></div>'), list = $('<ul class="zfc-dropdown-list zfc-dropdown-filter not-default"></ul>');
        if (label != null)
            ddLabel.html(zfTranslations.get(label));
        ddContainer.on("click", zfcDropdown.toggleDropdown);
        dd.data = data;
        dd.field = field;
        dd.label = label;
        dd.refreshFields = refreshFields;
        dd.filterList = [];
        dd.originalData = data;
        dd.activeData = data;
        for (var i in data) {
            dd.filterList.push(data[i]);
        }
        dd.append(ddLabel);
        ddContainer.append(listWrapper);
        dd.append(ddContainer);
        listWrapper.append(list);
        listWrapper.append($('<span class="zfc-filter-dropdown-toggler zfcui-icon zfcui-icon-arrow-down zfcui-color-cyan"></span>'));
        dd.beforeClick = function () { };
        dd.afterClick = function () { };
        dd.reset = function (skipClick) {
            dd.activeId = false;
            if (skipClick != true)
                dd.beforeClick("false");
            dd.labelItem.text(zfcDropdown.dropdownDefault);
            dd.resetItem.detach();
            if (skipClick != true)
                dd.afterClick("false");
        };
        dd.select = function (id) {
            if (!dd.data[id]) {
                return;
            }
            dd.data[id].elem.select(id);
        };
        dd.loadList = function (activeValue) {
            var d = dd.activeData;
            list.empty();
            dd.list = {};
            dd.labelItem = $('<li class="zfc-dropdown-active-filter-selected">' +
                zfcDropdown.dropdownDefault +
                "</li>");
            dd.resetItem = $('<li class="zfc-dropdown-active-filter-reset">' +
                zfcDropdown.dropdownDefaultReset +
                "</li>");
            dd.resetItem.on("click", dd.reset);
            list.append(dd.labelItem);
            dd.removeClass("zfc-dropdown-disabled");
            if (!Object.keys(d).length) {
                dd.addClass("zfc-dropdown-disabled");
                return;
            }
            for (var i in d) {
                if (d[i].value.trim() == activeValue)
                    dd.activeId = i;
                dd.list[i] = $('<li data-value="' +
                    d[i].value +
                    '">' +
                    d[i].value +
                    " (" +
                    d[i].count +
                    ")" +
                    "</li>");
                dd.list[i].id = i;
                d[i].ID = i;
                dd.list[i].data = d[i];
                dd.list[i][0].listItem = dd.list[i];
                d[i].elem = dd.list[i];
                dd.list[i].select = function (id) {
                    list.children().removeClass("zfc-dropdown-filter-active");
                    dd.data[id].elem.addClass("zfc-dropdown-filter-active");
                    list
                        .children()
                        .first()
                        .text(d[id].value + " (" + d[id].count + ")");
                };
                dd.list[i].on("click", function () {
                    dd.activeId = this.listItem ? this.listItem.id : false;
                    dd.beforeClick(this.listItem ? this.listItem.id : "false");
                    dd.change = true;
                    dd.list[dd.activeId].select(dd.activeId);
                    dd.afterClick(this.listItem ? this.listItem.id : "false");
                    if (dd.activeId) {
                        dd.resetItem.insertAfter(dd.labelItem);
                    }
                });
                list.append(dd.list[i]);
            }
            if (dd.activeId) {
                dd.resetItem.insertAfter(dd.labelItem);
                dd.select(dd.activeId);
            }
        };
        dd.loadList(activeValue);
        return dd;
    }
    static updateList(dropdown, values, activeValue) {
        var newArr = [];
        dropdown.originalData.forEach(function (active) {
            if ((values.hasOwnProperty(active.name) ||
                active.name === " " + zfcDropdown.dropdownAll) &&
                active.name !== "")
                newArr.push(active);
        });
        dropdown.activeData = newArr;
        dropdown.data = newArr;
        dropdown.loadList(activeValue);
        if (activeValue == null)
            dropdown.reset(true);
    }
    static resetList(dropdown) {
        dropdown.activeData = dropdown.originalData;
        dropdown.data = dropdown.originalData;
        dropdown.loadList();
        dropdown.reset(true);
    }
    static unbindEvents() {
        zfc.document.off("keydown.zfcDropdown", zfcDropdown.bindKeydown);
        zfc.body.off("click.zfcDropdown", zfcDropdown.bindBodyClick);
        zfcDropdown.currentDropDown.off("mousemove.zfcDropdown", zfcDropdown.onMouseMove);
        zfcDropdown.currentDropDown
            .find("li")
            .off("mouseenter.zfcDropdown", zfcDropdown.onMouseEnter);
        zfcDropdown.eventsBound = false;
        zfcDropdown.currentDropDown.scrollTop(0);
    }
    static bindBodyClick(e) {
        e.stopPropagation();
        if (!zfcDropdown.dropdownContainer.is(e.target) &&
            !zfcDropdown.dropdownContainer.has(e.target).length) {
            zfcDropdown.closeOpenFilters();
        }
    }
    static getScrollPos(index) {
        var scrollTopIndex = Math.round(zfcDropdown.currentDropDown.scrollTop() / 52);
        if (!index) {
            zfcDropdown.currentDropDown.scrollTop(0);
        }
        else if (index < scrollTopIndex) {
            zfcDropdown.currentDropDown.scrollTop(zfcDropdown.currentDropDown.scrollTop() - 52);
        }
        else if (index > scrollTopIndex + 7) {
            zfcDropdown.currentDropDown.scrollTop(index * 52);
        }
        else if (!(index < scrollTopIndex + 7)) {
            zfcDropdown.currentDropDown.scrollTop(zfcDropdown.currentDropDown.scrollTop() + 52);
        }
    }
    static bindKeydown(e) {
        var currentListItems = zfcDropdown.currentDropDown.find("li:not(.zfc-dropdown-active-filter-selected):visible");
        var currentActive, currentIndex, newIndex;
        if (!zfcDropdown.mousemoveBound) {
            zfcDropdown.currentDropDown.on("mousemove.zfcDropdown", zfcDropdown.onMouseMove);
            currentListItems.off("mouseenter.zfcDropdown", zfcDropdown.onMouseEnter);
            zfcDropdown.mousemoveBound = true;
        }
        currentActive = zfcDropdown.currentDropDown.find(".filterHovered");
        switch (e.which) {
            case 38:
                currentIndex = currentListItems.index(currentActive);
                newIndex = currentIndex - 1;
                if (newIndex < 0) {
                    newIndex = currentListItems.length - 1;
                }
                currentListItems.eq(currentIndex).removeClass("filterHovered");
                currentListItems.eq(newIndex).addClass("filterHovered");
                break;
            case 40:
                currentIndex = currentListItems.index(currentActive);
                newIndex = currentIndex + 1;
                if (newIndex > currentListItems.length - 1) {
                    newIndex = 0;
                }
                currentListItems.eq(currentIndex).removeClass("filterHovered");
                currentListItems.eq(newIndex).addClass("filterHovered");
                break;
            case 13:
                if (zfcDropdown.currentDropDown.find(".filterHovered").length) {
                    zfcDropdown.currentDropDown.find(".filterHovered").trigger("click");
                }
            default:
                return;
        }
        zfcDropdown.getScrollPos(newIndex);
        e.preventDefault();
    }
    static toggleDropdown(e) {
        var that = $(this), thatList = that.find(".zfc-dropdown-list"), calcedHeight = 0, isOpen = that.closest(".zfc-dropdown-list-toggled").length;
        if (that.closest(".zfc-dropdown-disabled").length) {
            return;
        }
        e.stopPropagation();
        zfcDropdown.closeOpenFilters();
        if (isOpen) {
            return;
        }
        zfcDropdown.currentDropDown = thatList;
        if (!zfcDropdown.eventsBound) {
            zfc.document.on("keydown.zfcDropdown", zfcDropdown.bindKeydown);
            zfc.body.on("click.zfcDropdown", zfcDropdown.bindBodyClick);
            zfcDropdown.currentDropDown.on("mousemove.zfcDropdown", zfcDropdown.onMouseMove);
            zfcDropdown.eventsBound = true;
        }
        that.addClass("zfc-dropdown-list-toggled");
        if (zfcDropdown.currentDropDown
            .find("li")
            .not(".zfc-dropdown-active-filter-selected")
            .not(".zfc-dropdown-filter-active").length > 8) {
            zfcDropdown.currentDropDown.css("overflow-y", "scroll");
        }
        else {
            zfcDropdown.currentDropDown.css("overflow-y", "hidden");
        }
        thatList.find("li:visible").each(function () {
            calcedHeight += $(this).outerHeight();
        });
        thatList.height(calcedHeight);
        thatList
            .find("li:not(.zfc-dropdown-active-filter-selected):visible:first")
            .addClass("filterHovered");
    }
    static toggleCategory(e) {
        e.stopPropagation();
        var that = $(this);
        that.siblings().removeClass("zfc-dropdown-filter-active");
        that.addClass("zfc-dropdown-filter-active");
        zfcDropdown.activeCategory = that.data("value");
        that
            .siblings(".zfc-dropdown-active-filter-selected")
            .attr("data-value", zfcDropdown.activeCategory)
            .text(zfcDropdown.activeCategory);
        zfcDropdown.unbindEvents();
        zfcDropdown.closeOpenFilters();
    }
    static closeOpenFilters() {
        if (!zfcDropdown.currentDropDown) {
            return;
        }
        zfcDropdown.currentDropDown
            .find(".filterHovered")
            .removeClass("filterHovered");
        zfcDropdown.currentDropDown.css("overflow-y", "hidden");
        zfcDropdown.currentDropDown
            .closest(".zfc-dropdown-list-toggled")
            .removeClass("zfc-dropdown-list-toggled")
            .find("ul")
            .height("");
        zfcDropdown.unbindEvents();
    }
    static onMouseMove() {
        var that = $(this);
        that.off("mousemove.zfcDropdown", zfcDropdown.onMouseMove);
        that.find("li").on("mouseenter.zfcDropdown", zfcDropdown.onMouseEnter);
        zfcDropdown.mousemoveBound = false;
    }
    static onMouseEnter() {
        var thatLi = $(this);
        thatLi.siblings().removeClass("filterHovered");
        thatLi.addClass("filterHovered");
    }
    static init() {
        try {
            (zfcDropdown.dropdownDefault = zfTranslations.get("show_all")),
                (zfcDropdown.dropdownDefaultReset = zfTranslations.get("reset_filter")),
                (zfcDropdown.dropdownAll = zfTranslations.get("all")),
                (zfcDropdown.dropdownContainer = $(".zfc-dropdown-container"));
            zfcDropdown.dropdownContainer
                .off("click.zfcDropdown")
                .on("click.zfcDropdown", zfcDropdown.toggleDropdown);
            zfcDropdown.dropdownContainer
                .find("li:not(.zfc-dropdown-active-filter-selected)")
                .off("click.zfcDropdown")
                .on("click.zfcDropdown", zfcDropdown.toggleCategory);
        }
        catch (err) {
            console.log("Initalization failed: zfcDropdown.init() " + err.message);
        }
    }
}
zfcDropdown.activeCategory = null;
zfcDropdown.eventsBound = false;
zfcDropdown.mousemoveBound = false;
try {
    zfUtils.onReady(zfcDropdown.init);
}
catch (err) {
    console.log("Initalization failed: zfcDropdown.init() " + err.message);
}
